<div class="messages-container">
  <h1 class="page-title">Message Center</h1>

  <div class="filters-bar">
    <ui-select
      label="Category"
      [options]="categoryOptions()"
      [formControl]="categoryControl"
    ></ui-select>

    <ui-select
      label="Status"
      [options]="readOptions"
      [formControl]="readControl"
    ></ui-select>

    <ui-select
      label="Order"
      [options]="orderOptions"
      [formControl]="orderControl"
    ></ui-select>
  </div>

  @if (!messages().length && !isLoading()) {
    <div class="empty-state">
      <h4>{{ emptyStateMessage() }}</h4>
    </div>
  }

  @if (isInitialLoad()) {
    <div class="loading-state">Loading messages...</div>
  }

  @if (messages().length) {
    <div class="table-wrapper">
      <shared-table [data]="messages()" [columns]="columns" title="">
        <ng-template columnTemplate="name" let-msg>
          <span (click)="openPatientMessages(msg)" class="clickable">
            {{ msg.from.firstname }} {{ msg.from.lastname }}
            @if (msg.from.state) {
              - {{ msg.from.state.code }}
            }
          </span>
        </ng-template>

        <ng-template columnTemplate="content" let-msg>
          <p class="message-content clickable" [innerHTML]="(msg | messageContent).html" (click)="openPatientMessages(msg)"></p>
            @for (widget of (msg | messageContent).widgets; track $index) {
              <ng-container *ngComponentOutlet="widget.component; inputs: widget.inputs" />
            }
        </ng-template>

        <ng-template columnTemplate="sent" let-msg>
          <span (click)="openPatientMessages(msg)" class="clickable">{{ msg.sent | date: 'dd/MMM/yy h:mm a' }}</span>
        </ng-template>

        <ng-template columnTemplate="status" let-msg>
          <span (click)="openPatientMessages(msg)" class="clickable">{{ msg.read ? 'Read' : 'Unread' }}</span>
        </ng-template>
      </shared-table>
    </div>

    <div class="pagination-bar">
      <span class="total-count">Total: {{ metadata()?.total ?? 0 }}</span>
      <ui-pagination
        [totalPages]="totalPages()"
        [currentPage]="currentPage()"
        (pageChange)="onPageChange($event)"
      ></ui-pagination>
    </div>
  }
</div>
